import { apiFetch } from "./api";
import { OhioMoveListResponse, OhioMoveDetailResponse } from "../types/fyo";

export interface InfluencedRelocationFilters {
  status?:          string;
  baseline_state?:  string;
  name?:            string;
  window_expired?:  boolean;
  limit?:           number;
  offset?:          number;
}

export function fetchOhioMoveDetail(rms_candidate_id: number | string): Promise<OhioMoveDetailResponse> {
  return apiFetch(`/ohio/moves/${rms_candidate_id}`);
}

export function fetchOhioMoves(filters: InfluencedRelocationFilters = {}): Promise<OhioMoveListResponse> {
  const q = new URLSearchParams();
  if (filters.status)                  q.set("status",          filters.status);
  if (filters.baseline_state)          q.set("baseline_state",  filters.baseline_state);
  if (filters.name)                    q.set("name",            filters.name);
  if (filters.window_expired != null)  q.set("window_expired",  String(filters.window_expired));
  q.set("limit",  String(filters.limit  ?? 50));
  q.set("offset", String(filters.offset ?? 0));
  return apiFetch(`/ohio/moves?${q}`);
}
